document.addEventListener('DOMContentLoaded', () => {
  const quizSection = document.querySelector('.refresh-quiz-section');
  if (!quizSection) return; // Exit if the section isn't on the page

  const quizForm = quizSection.querySelector('#refresh-quiz-form');
  const quizSteps = quizSection.querySelectorAll('.quiz-step');
  const quizResultContainer = quizSection.querySelector('#quiz-result-container');
  const waitlistSignupContainer = quizSection.querySelector('#waitlist-signup-container');
  let currentStep = 0;
  let quizScores = {
    hydrate: 0,
    glow: 0
  };

  // Function to show a specific quiz step
  const showStep = (stepIndex) => {
    quizSteps.forEach((step, index) => {
      step.style.display = index === stepIndex ? 'block' : 'none';
    });
  };

  // Function to enable/disable the next button
  const updateNextButtonState = (stepIndex) => {
    const currentStepEl = quizSteps[stepIndex];
    const nextButton = currentStepEl.querySelector('.next-step-btn, #submit-quiz-btn');
    const radiosInStep = currentStepEl.querySelectorAll('input[type="radio"]');
    let isAnyRadioChecked = Array.from(radiosInStep).some(radio => radio.checked);

    if (nextButton) {
      nextButton.disabled = !isAnyRadioChecked;
    }
  };

  // Event listener for radio button changes to enable/disable next button
  quizSteps.forEach((step, stepIndex) => {
    const radios = step.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
      radio.addEventListener('change', () => updateNextButtonState(stepIndex));
    });
  });

  // Event listener for "Next" buttons
  quizSection.querySelectorAll('.next-step-btn').forEach(button => {
    button.addEventListener('click', () => {
      const selectedOption = quizSteps[currentStep].querySelector('input[type="radio"]:checked');
      if (selectedOption) {
        quizScores.hydrate += parseFloat(selectedOption.dataset.pointsHydrate || 0);
        quizScores.glow += parseFloat(selectedOption.dataset.pointsGlow || 0);
      }

      currentStep++;
      if (currentStep < quizSteps.length) {
        showStep(currentStep);
        updateNextButtonState(currentStep); // Update state for the new step
      }
    });
  });

  // Event listener for quiz submission
  quizForm.addEventListener('submit', (e) => {
    e.preventDefault();

    const selectedOption = quizSteps[currentStep].querySelector('input[type="radio"]:checked');
    if (selectedOption) {
      quizScores.hydrate += parseFloat(selectedOption.dataset.pointsHydrate || 0);
      quizScores.glow += parseFloat(selectedOption.dataset.pointsGlow || 0);
    }

    // Determine result
    let resultTitle = '';
    let resultDescription = '';
    let waitlistHeadingPrefix = '';

    if (quizScores.hydrate > quizScores.glow) {
      resultTitle = quizSection.dataset.hydrateResultTitle;
      resultDescription = quizSection.dataset.hydrateResultDesc;
      waitlistHeadingPrefix = quizSection.dataset.waitlistHeadingPrefixHydrate;
    } else if (quizScores.glow > quizScores.hydrate) {
      resultTitle = quizSection.dataset.glowResultTitle;
      resultDescription = quizSection.dataset.glowResultDesc;
      waitlistHeadingPrefix = quizSection.dataset.waitlistHeadingPrefixGlow;
    } else {
      // If scores are tied or zero, show neutral result
      resultTitle = quizSection.dataset.neutralResultTitle;
      resultDescription = quizSection.dataset.neutralResultDesc;
      waitlistHeadingPrefix = quizSection.dataset.waitlistHeadingPrefixNeutral;
    }

    // Display results
    quizForm.style.display = 'none';
    quizResultContainer.style.display = 'block';
    quizResultContainer.querySelector('#result-title').innerHTML = resultTitle;
    quizResultContainer.querySelector('#result-description').innerHTML = resultDescription;

    // Display waitlist form
    waitlistSignupContainer.style.display = 'block';
    waitlistSignupContainer.querySelector('#waitlist-title').innerHTML = `Join the waitlist for ${waitlistHeadingPrefix}!`;
    waitlistSignupContainer.querySelector('#waitlist-description').innerHTML = quizSection.dataset.waitlistDescription;
  });

  // Initial state: show first step and update button state
  showStep(currentStep);
  updateNextButtonState(currentStep);
});